<template>
  <PageTemplate>
    <div class="row">
      <div class="col-lg-6">
        <h1>Profile</h1>
      </div>
      <div class="col-lg-6">
        <v-button-group is-right>
          <v-button
            size="lg"
            color="secondary"
            has-min-width
            @click="$router.push('/edit-profile')"
          >
            Edit Profile
          </v-button>
        </v-button-group>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <v-card title="Change Password">
          <v-fieldset
            id="current"
            v-model="oldPassword"
            text="Current password"
            placeholder="Must have at least 6 characters"
            help-text=""
            type="password"
            pattern="^\S{6,}"
            is-required
            is-revealable
          />
          <v-fieldset
            id="new"
            v-model="newPassword"
            text="New password"
            placeholder="Must have at least 6 characters"
            :help-text="newPasswordHelper"
            type="password"
            pattern="^\S{6,}"
            is-required
            is-revealable
          />
          <v-fieldset
            id="confirm"
            v-model="checkPassword"
            :help-text="confirmHelper"
            text="Confirm new password"
            type="password"
            pattern="^\S{6,}"
            is-required
            is-revealable
          />
          <v-button
            :is-disabled="!passwordsFilled || notSamePassword || checkSamePassword || !checkMinInput"
            size="lg"
            has-min-width
            @click="submit"
          >
            Save Changes
          </v-button>
        </v-card>
        <v-button
          color="transparent"
          @click="cancel"
        >
          Cancel
        </v-button>
      </div>
    </div>
  </PageTemplate>
</template>
<script>
  import PageTemplate from "@/templates/Page/index.vue";
  import Button from "@/atoms/Button";
  import Card from "@/molecules/Card";
  import ButtonGroup from "@/molecules/ButtonGroup";
  import Fieldset from "@/molecules/Fieldset";
  import {buildBreadCrumb} from "../common/tableFunctions";
  import {UPDATE_PASSWORD} from "@/store/actions.type";
  import routes from "@/common/routes";

  export default {
    name: "ChangePassword",
    components: {
      'v-button': Button,
      'v-button-group': ButtonGroup,
      'v-fieldset': Fieldset,
      'v-card': Card,
      PageTemplate
    },
    data() {
      return {
        oldPassword: '',
        newPassword: '',
        checkPassword: '',
        checkWithSpaceHelper: '',
        notSamePasswordHelper: '',
        checkSamePasswordHelper: '',
        checkMinInputHelper: '',
      }
    },
    computed: {
      checkMinInput() {
        return this.newPassword.length >= 6 && this.checkPassword.length >= 6;
      },
      newPasswordHelper() {
        return this.checkWithSpaceHelper + this.checkSamePasswordHelper + this.checkMinInputHelper;
      },
      confirmHelper() {
        return this.notSamePasswordHelper + this.checkMinInputHelper;
      },
      //  new password should not be the same as current one
      checkSamePassword() {
        if (this.oldPassword !== '' && this.newPassword !== '') {
          return (this.oldPassword === this.newPassword);
        } else {
          return false;
        }
      },
      //  confirmed password should be the same as new password
      notSamePassword() {
        if (this.newPassword !== '' && this.checkPassword !== '') {
          return (this.newPassword !== this.checkPassword);
        } else {
          return false;
        }
      },
      checkWithSpace() {
        return /\s/.test(this.newPassword)
      },
      passwordsFilled() {
        return (this.oldPassword !== '' && this.newPassword !== '' && this.checkPassword !== '')
      }
    },
    watch: {
      checkWithSpace(check) {
        (check ? this.checkWithSpaceHelper = 'Space character is not allowed. ' : this.checkWithSpaceHelper = '')
      },
      checkMinInput(check) {
        (check ? this.checkMinInputHelper = '' : this.checkMinInputHelper = 'New password requires at least 6 characters. ')
      },
      notSamePassword(check) {
        (check ? this.notSamePasswordHelper = 'Passwords do not match. ' : this.notSamePasswordHelper = '')
      },
      checkSamePassword(check) {
        (check ? this.checkSamePasswordHelper = 'New password should not be the same as the old one. ' : this.checkSamePasswordHelper = '')
      }
    },
    mounted() {
      this.updateBreadCrumb();
    },
    methods: {
      updateBreadCrumb: function () {
        let breadcrumbs = [];
        breadcrumbs['Dashboard'] = routes.DASHBOARD;
        breadcrumbs['Profile'] = routes.PROFILE;
        breadcrumbs['Change Password'] = '';
        this.$store.dispatch('updateBreadCrumbAction', buildBreadCrumb(breadcrumbs));
      },
      cancel: function () {
        this.$router.push(routes.PROFILE);
      },
      submit: function () {
        let params = {};
        params.oldPassword = this.oldPassword;
        params.newPassword = this.newPassword;
        this.$store.dispatch(UPDATE_PASSWORD, params)
          .then(response => {
            this.$notify({
              title: 'Success',
              text: response.message,
              type: 'success'
            });
            this.$router.push(routes.PROFILE)
          })
          .catch(error => {
            this.$notify({
              title: 'Error',
              text: error.data.message,
              type: 'error'
            });
          });
      }
    }
  }
</script>
